import React from "react";
import styled from "styled-components";

const TranscriptContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TranscriptEntry = styled.div`
  background: ${({ theme }) => theme.isDarkMode ? theme.colors.surface.default : theme.colors.surface.paper};
  border: 1px solid ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[700] : theme.colors.neutral[200]};
  border-radius: 8px;
  padding: 12px;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[100] : theme.colors.neutral[900]};
    box-shadow: ${({ theme }) => theme.isDarkMode ? "none" : theme.shadows.md};
  }
`;

const TimeAndSpeaker = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 14px;
  color: ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[100] : theme.colors.neutral[900]};

  .time {
    font-weight: 500;
  }

  .speaker {
    font-weight: 600;
    color: ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[100] : theme.colors.neutral[900]};
  }
`;

const TranscriptText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[100] : theme.colors.neutral[900]};
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
`;

const EmptyState = styled.div`
  color: ${({ theme }) => theme.isDarkMode ? theme.colors.neutral[100] : theme.colors.neutral[900]};
  text-align: center;
  padding: 20px;
  font-style: italic;
`;

export default function TranscriptViewer({ data = [] }) {
  if (!data || data.length === 0) {
    return <EmptyState>No transcript data available</EmptyState>;
  }

  return (
    <TranscriptContainer>
      {data.map((entry, index) => (
        <TranscriptEntry key={index}>
          <TimeAndSpeaker>
            <span className="time">{entry.time}</span>
            <span>–</span>
            <span className="speaker">{entry.speaker}</span>
          </TimeAndSpeaker>
          <TranscriptText>{entry.text}</TranscriptText>
        </TranscriptEntry>
      ))}
    </TranscriptContainer>
  );
}
